import { ICurrency } from "api/types/_currency";
import { ITopic } from "api/types/_topic";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string;

}

interface FilterCurrunciesProps {
  name?: string,
  dataList?: ICurrency[],
  initialValue?: Option[] | Option | undefined | null;
  onChangeSelect?: (params: Option) => void;
  placeholder?: string,
  isHasOptionAll?: boolean,
  optionAll?: undefined | Option,
}

const FilterCurrencies = ({
  name = '',
  initialValue = [],
  dataList = [],
  onChangeSelect,
  isHasOptionAll = false,

}: FilterCurrunciesProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };
  const optionAll: any = { label: '', code: t('All Currency Code'), value: '' };
  useEffect(() => {
    const resultOptions = dataList?.map((item) => ({ code: item?.code, label: `${item?.name} / ${item?.country}`, value: String(item?.code), country: item?.country })) || [] as Option[];
    const result: any = isHasOptionAll ? [optionAll].concat(resultOptions) : resultOptions;
    setOptions((_prev: any) => result);
    if (initialValue) {
      const val = result?.filter((e: any) => e.value === (initialValue as any)?.value)[0];
      setOnChangeOption(val);
    } else {
      setOnChangeOption(isHasOptionAll ? result[0] : null);
    }
  }, [JSON.stringify(dataList), JSON.stringify(initialValue)]);

  return (
    <React.Fragment>
      <Select
        cacheOptions
        options={options}
        isMulti={false}
        closeMenuOnSelect={true}
        name={name}
        value={initialValue}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{t('Select Currency Code')}...</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        formatOptionLabel={(option: any) => (<div className="d-flex">{option?.code} <div className="op ms-2"> {`${String(option?.label)}`}</div> </div>)}
        className="search-filter-currencies"
        classNamePrefix="name-prefix"
      />
    </React.Fragment>
  );
};

export default FilterCurrencies;
